import React, { useState, useReducer } from "react";
import { Row, Col, Input, Card, Button } from "antd";
import { useDispatch } from "react-redux";
import {
  EyeTwoTone,
  EyeInvisibleOutlined,
  Loading3QuartersOutlined,
} from "@ant-design/icons";
import "./Login.css";
import { setUserInfo } from "../store/actions/user";
import SignUp from "./Sign Up";
import { Validation } from "../Validation/VAlidation";
import constants from "../constants/constants.json";
import Axios from "axios";
import Message from "../helper/Message";
import { useHistory } from "react-router-dom";

const SET_EMAIL = "SET_EMAIL";
const SET_PASSWORD = "SET_PASSWORD";
const SET_VALIDEMAIL = "SET_VALIDEMAIL";
const RESET = "RESET";

const userRegister = (state, action) => {
  switch (action.type) {
    case SET_EMAIL:
      return {
        ...state,
        mail: action.mail,
        mailRequire: action.mailRequire,
      };
    case SET_PASSWORD:
      return {
        ...state,
        password: action.password,
        passwordRequire: action.passwordRequire,
      };
    case SET_VALIDEMAIL:
      return {
        ...state,
        mailerror: action.valid,
        mailRequire: action.mailRequire,
      };
    case RESET:
      return {
        ...state,

        mail: "",
        password: "",
        mailerror: true,
        nameRequire: false,
        mailRequire: false,
        passwordRequire: false,
      };
    default:
      return state;
  }
};

export default function Login(props) {
  const [tab, setTab] = useState("login");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [user, dispatchUser] = useReducer(userRegister, {
    mail: "",
    password: "",
    mailerror: true,
    nameRequire: false,
    mailRequire: false,
    passwordRequire: false,
  });

  const appLogin = async () => {
    if (user.mail === "" || user.password === "" || !user.mailerror) {
      Message.warning("fill all blanks");
      return;
    }
    try {
      setLoading(true);
      let response = await Axios.post(constants.url + "/user/login", {
        user: {
          mail: user.mail,
          password: user.password,
        },
      });

      if (response.data.status === 202) {
        localStorage.setItem("pnsToken", response.data.result.session.token);
        dispatch(
          setUserInfo({
            personal: {
              name: user.name,
              id: response.data.result.user.id,
              email: user.mail,
            },
          })
        );

        history.replace("/dashboard");
      } else {
        Message.warning(response.data.result.message);
        setLoading(false);
      }
      setLoading(false);
    } catch (err) {
      Message.error("Communication error");
      setLoading(false);
    }
  };
  return (
    <Row className="login-container" justify="center" align="middle">
      <Col xs={24} sm={17} md={13} lg={9} xl={7}>
        <Card bodyStyle={{ padding: "0px" }} className="login-card">
          <Row className="login-tab-container">
            <Col
              onClick={() => setTab("login")}
              className={
                tab === "login" ? "tab-login tab-selected" : "tab-login"
              }
              span={12}
            >
              <span>Login</span>
            </Col>
            <Col
              onClick={() => setTab("signup")}
              className={
                tab === "signup" ? "tab-signup tab-selected" : "tab-signup"
              }
              span={12}
            >
              <span>SignUp</span>
            </Col>
          </Row>
          {tab === "login" ? (
            <Row
              gutter={[10, 20]}
              className="content-tab-login"
              justify="center"
            >
              <Col span={24}>
                <Row justify="center">
                  <Col
                    // className="column-flex-style"
                    xs={24}
                    sm={20}
                    lg={16}
                    xl={16}
                  >
                    <span className="label">Email</span>
                    <Input
                      className="login-input"
                      type="email"
                      id="email"
                      onChange={(e) => {
                        dispatchUser({ type: SET_EMAIL, mail: e.target.value });
                      }}
                      onBlur={(e) => {
                        let valid = Validation.emailValidation(e.target.value);
                        dispatchUser({
                          type: SET_VALIDEMAIL,
                          valid: valid,
                          mailRequire: e.target.value.length < 1 ? true : false,
                        });
                      }}
                    />
                    {!user.mailerror ? (
                      <span className="login-valid-email">
                        email is incorrect
                      </span>
                    ) : null}
                    {user.mailRequire ? (
                      <span className="login-require">email is require</span>
                    ) : null}
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row justify="center">
                  <Col
                    // className="column-flex-style"
                    xs={24}
                    sm={20}
                    lg={16}
                    xl={16}
                  >
                    {/* <span className="label">email</span> <Input /> */}

                    <span className="label">Password</span>
                    <Input.Password
                      className="login-input"
                      type="password"
                      id="password"
                      iconRender={(visible) =>
                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                      }
                      onChange={(e) => {
                        dispatchUser({
                          type: SET_PASSWORD,
                          password: e.target.value,
                        });
                      }}
                      onBlur={(e) => {
                        dispatchUser({
                          type: SET_PASSWORD,
                          password: e.target.value,
                          passwordRequire:
                            e.target.value.length < 1 ? true : false,
                        });
                      }}
                    />
                    {user.passwordRequire ? (
                      <span className="login-require">password is require</span>
                    ) : null}
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <div className="login-button-container">
                  <Button
                    type="primary"
                    onClick={appLogin}
                    loading={loading ? <Loading3QuartersOutlined spin /> : false}
                    style={{
                      marginTop: "20px",
                    }}
                  >
                    Login
                  </Button>
                </div>
              </Col>
            </Row>
          ) : (
            <SignUp />
          )}
        </Card>
      </Col>
    </Row>
  );
}
